<template>
  <div id="app">
    <Hender></Hender>
    <keep-alive>
      <router-view />
    </keep-alive>
    <Footer></Footer>
  </div>
</template>

<script>
import Hender from "@/commonality/hender.vue";
import Footer from "@/commonality/footer.vue";
export default {
  name: "App",
  components: { Hender, Footer }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  height: 100%;
}
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue